import * as React from 'react'

import { LOCIZE_NAMESPACE } from 'main/common'
import { i18nKeyPrefix } from 'main/components/tour/i18n'
import SchoolSummary from 'main/components/tour/ScheduleTourModal/common/SchoolSummary'
import { Button } from 'main/ui'
import { momentFromDateTime } from 'main/util/moment'
import { useTranslation } from 'react-i18next'
import { RequestTourModal_school, RequestTourModal_tourRequests_availabilities } from '../../gql'
import {
  ConfirmationText,
  Container,
  SchoolSummaryContainer,
  TimesContainer,
} from './Confirmation.styles'

const PRE = `${i18nKeyPrefix}-REQUEST-MODAL-CONFIRMATION`
const DATE_TIME_FORMAT = 'dddd, MMMM D YYYY · h:mma'

interface IProps {
  school: RequestTourModal_school
  availabilities: RequestTourModal_tourRequests_availabilities[]
  onComplete: () => void
}

export default function Confirmation(props: IProps) {
  const { school, onComplete, availabilities } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const directorName = school.director?.name

  const legibleAvailabilities = availabilities.map(availability =>
    momentFromDateTime(availability.beginsAt, school.timezone),
  )

  return (
    <Container>
      <SchoolSummaryContainer>
        <SchoolSummary school={school} />
      </SchoolSummaryContainer>

      <TimesContainer>
        <ConfirmationText>{t(`${PRE}-TIME-TITLE`)}</ConfirmationText>
        {legibleAvailabilities.map((opening, idx) => {
          return <ConfirmationText key={idx}>{opening.format(DATE_TIME_FORMAT)}</ConfirmationText>
        })}
      </TimesContainer>

      <ConfirmationText>{t(`${PRE}-INFO`, { directorName })}</ConfirmationText>

      <Button full onClick={onComplete}>
        {t(`${PRE}-DONE`)}
      </Button>
    </Container>
  )
}
